const React = require('react');
const {FormWrapper} = require("../../../../../dumb/FormHandlers");
const {UserRegistrationFooter} = require("../../../../../dumb/AdminHelpers/AdminUserRegistration");
const {AdminDetailsRow, AdminDetailsCol, AdminDetailsItem} = require("../../../../../dumb/AdminHelpers/AdminLayout");

const {apiAdminMerchantActivate} = require("../../../../../../api/admin/retailersCreate");
const openPopupActivateRetailer = require('./utils/openPopupActivateRetailer');

const {
  COMPANY_DATA,
  PROFILE_DATA,
  OWNER_DATA
} = require('./constants');

module.exports = ({stepsData, activeUserId}) => {

  const companyData = stepsData.company || {};
  const profilesList = companyData.profiles || [];
  const ownersList = companyData.owners || [];

  return (
    <>
      <AdminDetailsRow>
        {COMPANY_DATA.map((el, id) => (
          <AdminDetailsCol key={id}>
            <AdminDetailsItem
              {...el}
              data={stepsData.company}
            />
          </AdminDetailsCol>
        ))}
      </AdminDetailsRow>
      {profilesList.map((profile, i) => {
        return (
          <React.Fragment key={i}>
            <div className="w h1 mt32 bg2C2D30" />
            <AdminDetailsRow>
              {PROFILE_DATA.map((el, id) => (
                <AdminDetailsCol key={id}>
                  <AdminDetailsItem
                    {...el}
                    data={profile}
                  />
                </AdminDetailsCol>
              ))}
            </AdminDetailsRow>
          </React.Fragment>
        )
      })}
      {ownersList.map((owner, i) => {
        return (
          <React.Fragment key={i}>
            <div className="w h1 mt32 bg2C2D30" />
            <AdminDetailsRow>
              {OWNER_DATA.map((el, id) => (
                <AdminDetailsCol key={id}>
                  <AdminDetailsItem
                    {...el}
                    data={owner}
                  />
                </AdminDetailsCol>
              ))}
            </AdminDetailsRow>
          </React.Fragment>
        )
      })}
      <UserRegistrationFooter
        submitBtnProps={{
          text: 'Activate',
          changesCheckDisabled: true,
          onClick: () => openPopupActivateRetailer({account_id: activeUserId})
        }}
        nextStepBtnProps={{
          disabled: true
        }}
      />
    </>
  )
}
